module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "part-h"
  }, [_c('span', [_vm._v("PART ONE")])]), _vm._v(" "), _c('p', {
    staticClass: "part-title"
  }, [_c('span', [_c('i', [_vm._v("Perama")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', [_c('i', [_vm._v("Here great trees cool-shaded grow, pear, pomegranate, rich apple, honey-sweet fig and blossoming olive, forever bearing fruit, winter and summer never stripped, but everblowing the western wind brings fruit to birth and ripens others. Pear follows pear, apple after apple grows, fig after fig, and grape yields grape again.")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', [_vm._v("–H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OMER")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a2b3892","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/part01.vue
// module id = 75
// module chunks = 0